import { History as HistoryIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { ResourceTypes } from 'parkchirp-shared/enums';
import { FC, useContext } from 'react';

import { CommonContext } from '../../contexts';
import { AuditHistoryModal } from './auditHistoryModal';

type ModalProps = {
	title: string;
	label: string;
	resourceId: string;
	resourceType: ResourceTypes;
	timezone?: string;
};

export const AuditHistoryButton: FC<ModalProps> = ({ title, label, resourceId, resourceType, timezone }) => {
	const { setShowDialog, hasComponentAccess, AccessControlledComponents } = useContext(CommonContext);

	const handleAuditHistory = async () => {
		const auditHistory = (
			<AuditHistoryModal
				title={title}
				resourceId={String(resourceId)}
				resourceType={resourceType}
				timezone={timezone}
				onClose={() => {
					setShowDialog(null);
				}}
			/>
		);

		setShowDialog(auditHistory);
	};

	return hasComponentAccess(AccessControlledComponents.AuditHistoryTable) ? (
		<Button
			title='View Audit History'
			startIcon={<HistoryIcon />}
			color='primary'
			size='small'
			variant='outlined'
			sx={{ marginRight: '5px ' }}
			onClick={() => {
				handleAuditHistory();
			}}
		>
			{label}
		</Button>
	) : null;
};
